export function slideIn() {
  $('.p-pageAchievement__item').on({
    mouseenter: function () {
      $(this).find('.js-slideIn').show(); // アニメーションなしで表示
    },
    mouseleave: function () {
      $(this).find('.js-slideIn').hide(); // アニメーションなしで非表示
    },
  });
}
